import { MCLogger } from '@mc/logger';

export const parseJsonData = <T>(data: string): T | null => {
  try {
    const parsedData = JSON.parse(data) as T;
    return parsedData;
  } catch (error) {
    MCLogger.error('Error parsing JSON data:', error);
    return null;
  }
};
